module.exports = __webpack_public_path__ + "img/blog-03.70fae66f.jpg";